module.exports = __webpack_public_path__ + "static/media/Matt Maple Headshot_1685545985452.cb22ea33.jpg";